import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function StickyBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 shadow-md border-b border-red-700" data-id="element-278">
      <div className="max-w-7xl mx-auto px-4 py-2 flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6" data-id="element-279">
        <p className="text-white font-bold text-sm md:text-base uppercase tracking-wide" data-id="element-280">
          Questa offerta scade presto
        </p>
        <div className="scale-75 md:scale-90 origin-center" data-id="element-281">
          <CountdownTimer variant="dark" data-id="element-282" />
        </div>
      </div>
    </div>;
}